export const MODEL_PROFILE_MAX_LENGTH = 16000
export const profileLength = (value) => Array.from(String(value || '')).length

export function modelProfileSummary(value, limit = 220) {
  const text = String(value || '').replace(/\s+/g, ' ').trim()
  const chars = Array.from(text)
  return chars.length > limit ? `${chars.slice(0, limit).join('')}…` : text
}

export function buildModelSetupPayload(draft, canManageModelDefaultConfig, timezones = []) {
  const description = String(draft.description || '').trim()
  if (profileLength(description) > MODEL_PROFILE_MAX_LENGTH) {
    throw new Error(`Model profile is too long: maximum ${MODEL_PROFILE_MAX_LENGTH.toLocaleString('en-US')} characters. Your text has not been trimmed.`)
  }
  const timezone = String(draft.timezone || '').trim()
  if (timezone) {
    try {
      if (timezones.length && !timezones.includes(timezone)) throw new Error('Unknown timezone')
      new Intl.DateTimeFormat('en-US', { timeZone: timezone }).format()
    } catch {
      throw new Error('Choose a valid timezone, for example America/Chicago or America/New_York. State names such as America/Texas are not timezones.')
    }
  }
  const maxPrice = String(draft.max_message_price ?? '').trim() === '' ? null : Number(draft.max_message_price)
  if (maxPrice !== null && (!Number.isInteger(maxPrice) || maxPrice < 3 || maxPrice > 200)) {
    throw new Error('Max message price must be a whole number from 3 to 200, or empty to use the default.')
  }
  const payload = { description, timezone, max_message_price: maxPrice,
    automation_mode: draft.automation_mode, bot_paused: Boolean(draft.bot_paused),
    telegram_alerts_enabled: Boolean(draft.telegram_alerts_enabled) }
  if (canManageModelDefaultConfig) {
    const configId = String(draft.default_config_id ?? '').trim() === '' ? null : Number(draft.default_config_id)
    if (configId !== null && (!Number.isSafeInteger(configId) || configId <= 0)) {
      throw new Error('Choose an existing graph configuration, or use the active global configuration.')
    }
    payload.default_config_id = configId
  }
  return payload
}
